import { GrowthBook } from '@growthbook/growthbook'
import type { JSONValue } from '@growthbook/growthbook/src/types/growthbook'

const EMPTY_GROWTHBOOK_PAYLOAD: Record<string, any> = {
	status: 200,
	features: {},
	dateUpdated: '',
}

export const gbAttributes = (user: any) => {
	return {
		id: user.id,
		email: user.email,
	}
}

export default defineNuxtPlugin(async (nuxtApp) => {
	const config = useRuntimeConfig()
	const payloadState = useState<Record<string, any> | null>('gb_payload', () => null)

	const gb = new GrowthBook({
		apiHost: config.public.feature_flags.apiHost,
		clientKey: config.public.feature_flags.clientKey,
		enableDevMode: config.public.feature_flags.enableDevMode,
	})

	if (import.meta.server) {
		try {
			const payload = await $fetch<Record<string, any>>('/api/growthbook/features')
			payloadState.value = payload ?? EMPTY_GROWTHBOOK_PAYLOAD
			gb.setPayload(payloadState.value) // ✅ reemplaza setFeatures
		} catch (error: any) {
			const statusCode = error?.statusCode ?? error?.response?.status
			console.warn(`[growthbook] SSR payload fetch failed (status: ${statusCode ?? 'unknown'}), using empty payload`)
			payloadState.value = EMPTY_GROWTHBOOK_PAYLOAD
			gb.setPayload(EMPTY_GROWTHBOOK_PAYLOAD)
		}
	} else {
		if (payloadState.value) {
			gb.setPayload(payloadState.value) // ✅ consistente con SSR
		} else {
			// Evita retrasar el montaje cliente cuando no hay payload SSR disponible.
			void gb.init()
		}
	}

	nuxtApp.provide('feature', gb)
	nuxtApp.provide('hasFeature', (f: string) => gb.isOn(f.toLowerCase()))
	nuxtApp.provide('getFeature', (key: string, defaultValue: JSONValue) =>
		gb.getFeatureValue(key.toLowerCase(), defaultValue),
	)
})
